'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const CalendarDateIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.90005 3V7.5M15.1 3V7.5M20.2001 19.2H3.80005C3.20005 19.2 2.80005 18.8 2.80005 18.2V5.2H21.3V18.2C21.2 18.8 20.8001 19.2 20.2001 19.2Z",
          stroke: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.7 12.6C11.2 12.2 11.5 11.7 11.5 11C11.5 10.1 10.9 9.10004 9.39998 9.10004C8.69998 9.20004 7.99998 9.50004 7.69998 9.80004L7.49998 10L7.99998 10.9L8.29998 10.7C8.49998 10.6 8.89998 10.3 9.39998 10.3C10.2 10.3 10.4 10.8 10.4 11.2C10.4 12 9.59998 12.2 8.99998 12.2H8.19998V13.3H8.99998C9.29998 13.3 10.6 13.4 10.6 14.6C10.6 14.9 10.5 15.8 9.19998 15.8C8.59998 15.8 8.09998 15.6 7.89998 15.4L7.59998 15.2L7.09998 16.2L7.29998 16.4C7.59998 16.7 8.29998 16.9 9.09998 16.9C10.9 16.9 11.7 15.7 11.7 14.6C11.8 13.7 11.4 13 10.7 12.6Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.6 9.29999L13 10.2L13.3 11.3L14.3 10.7V16.7H15.5V9.29999H14.6Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpCalendarDateIcon = forwardRef(CalendarDateIcon);

export { VpCalendarDateIcon as default };
